import {
  PATH_MYINFO_OKR,
  PATH_TEAM_WORK,
  PATH_TOP_SAME_LEVEL,
  PATH_MY_SUBORDINATE,
  PATH_MY_MARK,
  PATH_MYINFO_GROUP,
  PATH_MYINFO_MYTIM,
  PATH_MYINFO_FOCUS,
  PATH_MYINFO_COLLECT,
  // PATH_MYINFO_DETAIL,
  PATH_SEARCH_PAGE,
  // PATH_ADD_OKR,
  PATH_ADD_SUCCESS,
  PATH_NOPC
} from "@/constants/URL";

import routerWithSidebar from "../routerWithSidebar";
import { ispc } from "@/utils/func";

export default {
  path: PATH_MYINFO_OKR,
  component: () =>
    import(/* webpackChunkName: "SidebarLayout" */ "@/layout/SidebarLayout/index.vue"),
  children: [
    {
      path: PATH_MYINFO_OKR,
      name: "myokr",
      components: routerWithSidebar(() =>
        import(/* webpackChunkName: "role" */ "@/views/myinfo/myokr/index.vue")
      ),
      beforeEnter: (to, from, next) => {
        if (!ispc) {
          next(PATH_NOPC);
        } else {
          next();
        }
      },
    },
    {
      path: PATH_MYINFO_GROUP,
      name: "group",
      components: routerWithSidebar(() =>
        import(/* webpackChunkName: "role" */ "@/views/myinfo/group/index.vue")
      )
    },
    {
      path: PATH_TEAM_WORK,
      name: "teamwork",
      components: routerWithSidebar(() =>
        import(/* webpackChunkName: "role" */ "@/views/myinfo/teamwork/index.vue")
      )
    },
    {
      path: PATH_MY_MARK,
      name: "mymark",
      components: routerWithSidebar(() =>
        import(/* webpackChunkName: "role" */ "@/views/myinfo/mymark/index.vue")
      )
    },
    {
      path: PATH_TOP_SAME_LEVEL,
      name: "topsamelevel",
      components: routerWithSidebar(() =>
        import(/* webpackChunkName: "role" */ "@/views/myinfo/topsamelevel/index.vue")
      )
    },
    {
      path: PATH_MY_SUBORDINATE,
      name: "subordinate",
      components: routerWithSidebar(() =>
        import(/* webpackChunkName: "role" */ "@/views/myinfo/subordinate/index.vue")
      )
    },
    //老创建已经废弃
    // {
    //   path: PATH_ADD_OKR,
    //   name: "addokr",
    //   components: routerWithSidebar(() =>
    //     import(/* webpackChunkName: "role" */ "@/views/myinfo/myokr/AddOkr.vue")
    //   )
    // },
    {
      path: PATH_ADD_SUCCESS,
      name: "addSussess",
      components: routerWithSidebar(() =>
        import(/* webpackChunkName: "role" */ "@/views/myinfo/myokr/AddSussess.vue")
      )
    },
    {
      path: PATH_MYINFO_MYTIM,
      name: "mytim",
      components: routerWithSidebar(() =>
        import(/* webpackChunkName: "user" */ "@/views/myinfo/mytim/index.vue")
      )
    },
    {
      path: PATH_MYINFO_FOCUS,
      name: "focus",
      components: routerWithSidebar(() =>
        import(/* webpackChunkName: "user" */ "@/views/myinfo/focus/index.vue")
      )
    },
    {
      path: PATH_MYINFO_COLLECT,
      name: "collect",
      components: routerWithSidebar(() =>
        import(/* webpackChunkName: "role" */ "@/views/myinfo/collect/index.vue")
      )
    },
    // {
    //   path: PATH_MYINFO_DETAIL,
    //   name: "okrdetail",
    //   components: routerWithSidebar(() =>
    //     import(/* webpackChunkName: "role" */ "@/views/myinfo/myokr/OkrDetail.vue")
    //   )
    // },
    {
      path: PATH_SEARCH_PAGE,
      name: "searchpage",
      components: routerWithSidebar(() =>
        import(/* webpackChunkName: "role" */ "@/views/searchPage/index.vue")
      )
    }
  ]
};
